import type { ProfileResponse } from "../services/types";
import type {User} from "../types";
import type { UserProfile } from "./compatibilityAI";
import { resolveAstrologyFromProfile, resolveNumerologyFromProfile } from "./detailedAnalysisStub";

const defaultPersonality: UserProfile["personality"] = {
  extroversion: 50,
  openness: 50,
  conscientiousness: 50,
  agreeableness: 50,
  emotionalStability: 50,
};

const defaultAstrology: UserProfile["astrology"] = {
  zodiacSign: "",
  element: "air",
  moonSign: "",
  ascendant: "",
};

const defaultNumerology: UserProfile["numerology"] = {
  lifePath: 1,
  soulUrge: 1,
  destiny: 1,
};

/** API profile → карточка избранного (web/app/types User). */
export function mapApiProfileToFavoriteUser(p: ProfileResponse): User {
  const photos =
    p.photos && p.photos.length > 0 ? p.photos : p.photo ? [p.photo] : [];
  return {
    id: p.id,
    name: p.name,
    age: p.age,
    location: p.location,
    bio: p.bio || "",
    photos,
    interests: p.interests || [],
    online: false,
  };
}

/** Map API ProfileResponse (camelCase from server) to local UserProfile for swipe / compatibility UI. */
export function mapApiProfileToUserProfile(p: ProfileResponse): UserProfile {
  const pers = (p.personality || {}) as Record<string, unknown>;
  const astro = (p.astrology || {}) as Record<string, unknown>;
  const num = (p.numerology || {}) as Record<string, unknown>;

  return {
    id: p.id,
    compatibilityScore: p.compatibilityScore,
    name: p.name,
    age: p.age,
    bio: p.bio || "",
    gender: p.gender,
    interests: p.interests || [],
    relationshipGoal: p.relationshipGoal || "",
    location: p.location || "",
    photo: p.photo || (p.photos && p.photos[0]) || "",
    photos: p.photos && p.photos.length > 0 ? p.photos : p.photo ? [p.photo] : [],
    lastSeenAt: p.lastSeenAt ?? null,
    personality: {
      extroversion: Number(pers.extroversion ?? defaultPersonality.extroversion),
      openness: Number(pers.openness ?? defaultPersonality.openness),
      conscientiousness: Number(pers.conscientiousness ?? defaultPersonality.conscientiousness),
      agreeableness: Number(pers.agreeableness ?? defaultPersonality.agreeableness),
      emotionalStability: Number(pers.emotionalStability ?? defaultPersonality.emotionalStability),
    },
    astrology: resolveAstrologyFromProfile(p.birthDate, p.age, astro) ?? defaultAstrology,
    numerology: resolveNumerologyFromProfile(p.birthDate, p.age, num) ?? defaultNumerology,
    birthDate: p.birthDate || "",
    birthTime: p.birthTime || "",
    birthCity: p.birthCity || "",
    lifestyle: p.lifestyle ?? null,
    likesCount: Number(p.likesCount ?? 0),
    superLikesCount: Number(p.superLikesCount ?? 0),
    matchFacts: p.matchFacts ?? [],
    superLikedMe: p.superLikedMe === true,
    superMessage: p.superMessage ?? null,
    isVerified: p.isVerified ?? false,
    verificationScore: p.verificationScore ?? null,
  };
}
